import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import {
  type LucideIcon,
  AlertTriangle,
  CheckCircle,
  FlaskConical,
  Shuffle,
} from "lucide-react"
import type { DeclarationPattern } from "../../api/types"
import { McPill } from "./McPill"

const PATTERN_META: Record<
  DeclarationPattern,
  {
    tone: "success" | "attention" | "info"
    icon: LucideIcon
    labelKey:
      | "MC_DECL_PATTERN_CORRECT_FILL"
      | "MC_DECL_PATTERN_BLANKET"
      | "MC_DECL_PATTERN_OWN_NUMBERS"
      | "MC_DECL_PATTERN_SDS"
  }
> = {
  "correct-fill": {
    tone: "success",
    icon: CheckCircle,
    labelKey: "MC_DECL_PATTERN_CORRECT_FILL",
  },
  "blanket-pdf": {
    tone: "attention",
    icon: AlertTriangle,
    labelKey: "MC_DECL_PATTERN_BLANKET",
  },
  "own-article-numbers": {
    tone: "attention",
    icon: Shuffle,
    labelKey: "MC_DECL_PATTERN_OWN_NUMBERS",
  },
  sds: { tone: "info", icon: FlaskConical, labelKey: "MC_DECL_PATTERN_SDS" },
}

interface PatternPillProps {
  pattern: DeclarationPattern | null | undefined
}

export function PatternPill({ pattern }: PatternPillProps) {
  const { translate } = useTranslation()
  const meta = pattern ? PATTERN_META[pattern] : undefined
  // Unknown or not-yet-classified pattern: render nothing rather than crash the
  // whole panel on an undefined lookup.
  if (!meta) return null
  const { tone, icon: Icon, labelKey } = meta
  return (
    <McPill tone={tone} icon={Icon}>
      {translate(labelKey)}
    </McPill>
  )
}
